import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import authAPI from "../authAPI";
import { selectAuthUserId } from "../../features/auth/AuthSlice";

export const useOrganizations = (includeInactive = false) => {
  const userId = useSelector(selectAuthUserId);

  return useQuery(
    ["organizations", includeInactive],
    () => authAPI.listOrganizations(includeInactive),
    {
      enabled: !!userId,
      // Refetch on mount to catch groups that were just synced
      refetchOnMount: true,
      // Don't cache empty results - groups might be syncing in background
      staleTime: 0,
      // Refetch every 3 seconds if empty (for first login scenario)
      refetchInterval: (data) => {
        if (data?.data && Array.isArray(data.data) && (data.data.length === 0)) {
          return 10000; // Refetch every 3 seconds when empty
        }
        if(data?.data && Array.isArray(data.data) && (data.data.length <= 10)) {
          return 20000;
        }
        return false; // Stop refetching when we have data
      },
    }
  );
};
